module.exports = __webpack_public_path__ + "static/media/privasee_inc.6b39ca80.png";